import styled from 'styled-components'

const iconSize = '46px'

export default styled.div`
  position: absolute;
  top: ${(props) => props.top || '54px'};
  ${(props) => {
    if (props.right) return `right: ${props.right};`
    else return `right: calc((${props.width} / 2 - (${iconSize} / 2)) * -1);`
  }}
  z-index: ${(props) => props.theme.zIndexModal};
  user-select: none;

  .content {
    position: relative;
    background: white;
    height: auto;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: ${(props) => props.width};
    cursor: default;
    &.dropdown {
      & > div {
        padding: 8px 15px;
        cursor: pointer;
        border-radius: 6px;
        &:hover {
          background-color: #efefef !important;
        }
      }
    }
  }
`
